import { Component, Inject, InjectionToken, HostListener, Optional, ChangeDetectionStrategy } from '@angular/core';
import { MdlDialogReference } from '@angular-mdl/core';

import { FormControl, Validators } from '@angular/forms';
import { invalidValues } from '../invalid-values.validator';
import { Email } from './email';
import { filter, map } from 'rxjs/operators';
import { EMAIL_PREFERENCE_STORAGE_TOKEN, EmailPreferencesStorage } from './email-preferences-storage';

export const EMAIL = new InjectionToken('Email');
export const USER_PK = new InjectionToken('userPk');

@Component({
    selector: 'email-address-form-dialog',
    template: require('./email-address-form-dialog.component.html'),
    styles: [require('./email-address-form-dialog.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailAddressFormDialog {
    public initialEmailAddress: string;
    public control: FormControl;

    constructor(
        @Inject(EMAIL_PREFERENCE_STORAGE_TOKEN)private readonly emailPreferencesStorage: EmailPreferencesStorage,
        private readonly dialog: MdlDialogReference,
        @Optional() @Inject(EMAIL) private readonly email: Email,
        @Inject(USER_PK) private readonly userPk: number,
    ) {
        this.initialEmailAddress = email ? email.emailAddress : '';

        this.control = new FormControl(this.initialEmailAddress);

        emailPreferencesStorage.emailPreferences.pipe(
            filter(prefs => !!prefs),
            map(prefs => {
                const emailAddresses = prefs.map(x => x.email.emailAddress);
                this.control.setValidators([Validators.required, Validators.pattern(/^[\w.-]*@[\w.-]*\.\w+$/), invalidValues(emailAddresses)]);
        })).toPromise();
        this.control.updateValueAndValidity();
        this.control.markAsUntouched();
    }

    public async submit() {
        if (this.control.invalid) {
            return;
        }

        let newEmail: Email = new Email();

        if (this.email) {
            this.email.emailAddress = this.control.value;
            newEmail = this.email;
        } else {
            newEmail.emailAddress = this.control.value;
            newEmail.isDefault = false;
        }

        await this.saveEmail(newEmail);
        this.dialog.hide();
    }

    public cancel() {
        this.dialog.hide();
    }

    @HostListener('document:keydown.esc')
    public close() {
        this.dialog.hide();
    }

    private async saveEmail(email: Email) {
        await this.emailPreferencesStorage.saveOrUpdateEmail(email, this.userPk);
    }
}